module.exports = __webpack_public_path__ + "img/辅助业务.a01bd94c.png";